export default __webpack_public_path__ + "static/media/genealoviz.9bd5ad3c.jpg";